import CchPipelineTab from "@/components/admin/CchPipelineTab";

const CchIntegrationSection = () => <CchPipelineTab />;

export default CchIntegrationSection;
